module.exports = __webpack_public_path__ + "img/triangle_down.1b2d9ec6.svg";